module.exports = __webpack_public_path__ + "img/logo.c05794c6.png";